module.exports = __webpack_public_path__ + "img/emptyStar.b698f07d.svg";